import { render, staticRenderFns } from "./debug.vue?vue&type=template&id=f8a1e280&scoped=true"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"
import style0 from "./debug.vue?vue&type=style&index=0&id=f8a1e280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a1e280",
  null
  
)

export default component.exports